import {createAction} from 'redux-actions';
import {getMediaOrders} from '@pluto/rest';
import {valueToMoment} from '@pluto/daterange-picker';
import {MediaOrderFilterParams} from '../../MediaOrdersTypes';

export const MEDIA_ORDERS_LIST_SET = 'MEDIA_ORDERS_LIST_SET';
export const MEDIA_ORDERS_LIST_RESET = 'MEDIA_ORDERS_LIST_RESET';

export const dateToUtc = (dateType: string, date?: string) => {
    const initialDateValue = valueToMoment(date || null).utc(true);

    if (!date) {
        return date;
    }

    if (dateType === 'start') {
        return initialDateValue.format();
    }

    return initialDateValue.add(1, 'd').add(-1, 's').format();
};

export const setMediaOrdersListAction = createAction(
    MEDIA_ORDERS_LIST_SET,
    async (params: MediaOrderFilterParams) => {
        const {
            importDateStart,
            importDateEnd,
            dateIssuedStart,
            dateIssuedEnd,
            ...restParams
        } = params;
        const body = {
            ...restParams,
            importDateFrom: dateToUtc('start', importDateStart),
            importDateTo: dateToUtc('end', importDateEnd),
            dateIssuedFrom: dateToUtc('start', dateIssuedStart),
            dateIssuedTo: dateToUtc('end', dateIssuedEnd),
        };

        return await getMediaOrders(body);
    }
);

export const resetMediaOrdersListAction = createAction(MEDIA_ORDERS_LIST_RESET);
